import { render, staticRenderFns } from "./SolNotification.vue?vue&type=template&id=f4659df6&scoped=true"
import script from "./SolNotification.vue?vue&type=script&lang=ts"
export * from "./SolNotification.vue?vue&type=script&lang=ts"
import style0 from "./SolNotification.vue?vue&type=style&index=0&id=f4659df6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4659df6",
  null
  
)

export default component.exports